import * as React from "react"
import * as ReactDOM from "react-dom"

interface IBannerListViewProps {

    ButtonText: string;
    itemProperties: {
        Title: string;
        Description: string;
        Link: string;
        OpenInNewWindow: string;
        ImageSource: string;
        MobileImageSource: string;
        ButtonText: string;
        spTitleFontSize: string;
        spDescFontSize: string;
        spTitleColor: string;
        spDescColor: string;
        spButtonColor: string;
        spButtonBackgroundColor: string;
    };
    initialState: BannerListViewModel<BannerListViewItemModel>;
}

class BannerListViewModel<T> {
    Autoplay: boolean;
    AutoplaySeconds: number;
    ButtonText: string;
    items: Array<T>;
    constructor() {
        this.items = new Array<T>();
    }
}

class BannerListViewItemModel {
    Title: string;
    Description: string;
    Link: string;
    OpenInNewWindow: boolean;
    ImageSource: string;
    MobileImageSource: string;
    ButtonText: string;
    spTitleFontSize: string;
    spDescFontSize: string;
    spTitleColor: string;
    spDescColor: string;
    spButtonColor: string;
    spButtonBackgroundColor: string;
}

export class BannerListView extends React.Component<IBannerListViewProps, BannerListViewModel<BannerListViewItemModel>>{
    private readonly DefaultAutoplaySeconds = 5;
    constructor(props: IBannerListViewProps) {
        super(props);
        this.state = (!this.props.initialState) ? new BannerListViewModel<BannerListViewItemModel>() : this.props.initialState;
    }

    componentDidMount() {
        let swiperConfig = {};
        if (this.state.Autoplay == true) {
            swiperConfig = {
                autoplay: {
                    delay: this.state.AutoplaySeconds ? this.state.AutoplaySeconds * 1000 : this.DefaultAutoplaySeconds * 1000
                }
            }
        }
        new window["Swiper"](".mySwiper", swiperConfig);
    }

    private carouselElement: HTMLElement;

    private getBannerImage = (item) => {
        var isMobile = Math.min(window.screen.width, window.screen.height) < 425 || navigator.userAgent.indexOf("Mobi") > -1;

        if (item.MobileImageSource && isMobile) {
            return item.MobileImageSource;
        }
        else{
            return item.ImageSource;
        }
    }

    render() {
        return <div className="main-slider">
            <div className="swiper mySwiper">
                <div className="swiper-wrapper">
                    {this.state.items.map((value, index, array) => {
                        return <div className="swiper-slide" style={{ background: `url('${this.getBannerImage(value)}')` }}>
                            <div className="container slider-cont">
                                <div className="slider-text">
                                    <h4 className="top-single">
                                    </h4>
                                    <h2 className="slider-head">{value.Title}</h2>
                                    <p className="slider-desc">{value.Description}</p>
                                    <a hidden={value.ButtonText == ""} href={value.Link ? value.Link : "#"} target={value.OpenInNewWindow ? "_blank" : "_self"} className="slider-btn" style={{ color: value.spButtonColor, backgroundColor: value.spButtonBackgroundColor }}>{value.ButtonText}
                                    </a>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./Views/src/Applicant/banner-list-view.tsx